import React from 'react';
import { isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography, IconButton } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { useTranslation } from 'react-i18next';
import AvatarWithBadge from 'sharedComponents/AvatarWithBadge';
import BidRequestPresenter from 'presenters/BidRequestPresenter';
import BuyerPresenter from 'presenters/BuyerPresenter';
import Icon from 'sharedComponents/Icon';

import useStyles from './useStyles';

const BuyerCard = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { isOnline, onBack, onClick, isHightlighted, bidRequest, buyer } = props;

  const isBidRequestPresent = isPresent(bidRequest);
  const loanAmmount = isBidRequestPresent ? BidRequestPresenter.readalbeLoanAmmount(bidRequest) : '--';
  const ltv = isBidRequestPresent ? BidRequestPresenter.readableLtv(bidRequest) : '--';
  const city = isBidRequestPresent ? BidRequestPresenter.city(bidRequest) : '--';

  const handleClickBack = event => {
    event.stopPropagation();
    onBack();
  };

  const isBuyerPresent = isPresent(buyer);
  const avatarLabel = isBuyerPresent ? BuyerPresenter.initials(buyer) : '';

  return (
    <div
      className={clsx(classes.container, { [classes.active]: isHightlighted, [classes.inActive]: !isHightlighted })}
      onClick={onClick}
      role="presentation"
    >
      <div className={classes.upperBar}>
        <div className={classes.buyerInfo}>
          <IconButton onClick={handleClickBack} className={classes.backButton}>
            <Icon name="backArrow" />
          </IconButton>
          <AvatarWithBadge isOnline={isOnline} label={avatarLabel} />
          {isBuyerPresent ? (
            <Typography variant="h2" noWrap className={classes.name}>
              {BuyerPresenter.fullName(buyer)}
            </Typography>
          ) : (
            <Skeleton className={classes.name} width={150} height={30} />
          )}
        </div>
        <IconButton onClick={onClick}>
          <Icon name="forwardArrow" />
        </IconButton>
      </div>
      <div className={classes.bottomBar}>
        <div className={clsx(classes.bottomBarItem, classes.bottomBarLeft)}>
          <Typography variant="subtitle1" color="secondary">
            {t('models.App.BidRequest.loanAmmount')}
          </Typography>
          <Typography variant="h2" className={classes.additionalText}>
            {loanAmmount}
          </Typography>
        </div>
        <div className={clsx(classes.bottomBarItem, classes.bottomBarCenter)}>
          <Typography variant="subtitle1" color="secondary">
            {t('models.App.BidRequest.ltv')}
          </Typography>
          <Typography variant="h2" className={classes.additionalText}>
            {ltv}
          </Typography>
        </div>
        <div className={clsx(classes.bottomBarItem, classes.bottomBarRight)}>
          <Typography variant="subtitle1" color="secondary">
            {t('models.App.BidRequest.city')}
          </Typography>
          <Typography variant="h2" noWrap className={classes.additionalText}>
            {city}
          </Typography>
        </div>
      </div>
    </div>
  );
};

BuyerCard.propTypes = {
  isOnline: PropTypes.bool.isRequired,
  isHightlighted: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  bidRequest: BidRequestPresenter.shape(),
  buyer: BuyerPresenter.shape(),
};

BuyerCard.defaultProps = {
  isHightlighted: false,
  bidRequest: {},
  buyer: {},
};

export default BuyerCard;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/MobileMessages/components/ChatPage/components/BuyerCard/BuyerCard.js